(function () {
  'use strict';

  var HUB = '/pages/vorsprung-suspension-service';
  var ITEMS = [
    { key: 'telum', label: 'Telum Coil Shocks', url: '/collections/vorsprung-telum-coil-shocks' },
    { key: 'smashpot', label: 'Smashpot', url: '/collections/smashpot-fork-coil-conversion-system' },
    { key: 'secus', label: 'Secus', url: '/collections/secus-air-spring-upgrade-kit' },
    { key: 'luftkappe', label: 'Luftkappe', url: '/collections/luftkappe-air-piston' },
    { key: 'fractive', label: 'Fractive', url: '/collections/fractive-tuning-kits' },
    { key: 'tractive', label: 'Tractive', url: '/collections/tractive-tuning-kits' }
  ];

  var DESTINATIONS = ITEMS.reduce(function (map, item) {
    map[item.key] = item.url;
    return map;
  }, {});

  var SERVICE_DESTINATIONS = Object.assign({}, DESTINATIONS, {
    telum: '/pages/vorsprung-telum'
  });

  function clean(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function pathOf(value) {
    try {
      return new URL(value, window.location.origin).pathname.replace(/\/$/, '') || '/';
    } catch (error) {
      return '';
    }
  }

  function keyFromText(value) {
    var text = clean(value)
      .replace(/^vorsprung\s+/, '')
      .replace(/\s+(fork coil conversion system|air spring upgrade kit|air piston|tuning kits?|rear coil shock)$/, '')
      .replace(/\s+coil shocks?$/, '')
      .trim();

    if (text.indexOf('telum') !== -1) return 'telum';
    if (text.indexOf('smashpot') !== -1) return 'smashpot';
    if (text.indexOf('secus') !== -1) return 'secus';
    if (text.indexOf('luftkappe') !== -1) return 'luftkappe';
    if (text.indexOf('fractive') !== -1) return 'fractive';
    if (text.indexOf('tractive') !== -1) return 'tractive';
    return '';
  }

  function updateCustomCjsMenu() {
    var cards = document.querySelectorAll('.cjs-brands-menu__brand');

    Array.prototype.forEach.call(cards, function (card) {
      var brandName = card.querySelector('.cjs-brands-menu__brand-name');
      if (!brandName || clean(brandName.textContent) !== 'vorsprung') return;

      var headerLink = card.querySelector('.cjs-brands-menu__brand-header a');
      if (headerLink) headerLink.setAttribute('href', HUB);

      var supportLink = card.querySelector('.cjs-brands-menu__brand-link');
      if (supportLink) supportLink.setAttribute('href', HUB);

      var modelLinks = card.querySelectorAll('.cjs-brands-menu__models a');
      Array.prototype.forEach.call(modelLinks, function (link) {
        var key = keyFromText(link.textContent);
        if (key && SERVICE_DESTINATIONS[key]) link.setAttribute('href', SERVICE_DESTINATIONS[key]);
      });
    });
  }

  function makeDesktopItem(item) {
    var li = document.createElement('li');
    li.className = 'nav-dropdown__item';
    li.setAttribute('data-cjs-vorsprung-item', item.key);

    var link = document.createElement('a');
    link.href = item.url;
    link.className = 'nav-dropdown__link link';
    link.setAttribute('data-type', 'menuitem');
    link.textContent = item.label;

    li.appendChild(link);
    return li;
  }

  function updateDesktopBrandsMenu() {
    var links = document.querySelectorAll('a.nav-dropdown__link');

    Array.prototype.forEach.call(links, function (vorsprungLink) {
      if (clean(vorsprungLink.textContent) !== 'vorsprung') return;

      var parentItem = vorsprungLink.closest('.nav-dropdown__item');
      if (!parentItem) return;

      var submenu = null;
      Array.prototype.some.call(parentItem.children, function (child) {
        if (child.tagName === 'UL' && child.classList.contains('nav-dropdown')) {
          submenu = child;
          return true;
        }
        return false;
      });
      if (!submenu) return;

      var existingLinks = submenu.querySelectorAll(':scope > .nav-dropdown__item > a.nav-dropdown__link');
      Array.prototype.forEach.call(existingLinks, function (link) {
        var key = keyFromText(link.textContent);
        if (!key || !DESTINATIONS[key]) return;
        link.href = DESTINATIONS[key];
        link.textContent = ITEMS.filter(function (item) { return item.key === key; })[0].label;
        var li = link.closest('.nav-dropdown__item');
        if (li) li.setAttribute('data-cjs-vorsprung-item', key);
      });

      ITEMS.forEach(function (item) {
        if (submenu.querySelector('[data-cjs-vorsprung-item="' + item.key + '"]')) return;
        submenu.appendChild(makeDesktopItem(item));
      });
    });
  }

  function makeMobileItem(item) {
    var li = document.createElement('li');
    li.className = 'mobile-menu__nav-item';
    li.setAttribute('data-cjs-vorsprung-item', item.key);

    var link = document.createElement('a');
    link.href = item.url;
    link.className = 'mobile-menu__nav-link';
    link.setAttribute('data-type', 'menuitem');
    link.textContent = item.label;

    li.appendChild(link);
    return li;
  }

  function updateMobileBrandsMenu() {
    var controls = document.querySelectorAll('#mobile-menu [aria-controls]');

    Array.prototype.forEach.call(controls, function (control) {
      if (clean(control.textContent) !== 'vorsprung') return;

      var panelId = control.getAttribute('aria-controls');
      if (!panelId) return;

      var panel = document.getElementById(panelId);
      if (!panel) return;

      var list = panel.querySelector('.mobile-menu__nav');
      if (!list) return;

      var existingLinks = list.querySelectorAll(':scope > .mobile-menu__nav-item > a.mobile-menu__nav-link');
      Array.prototype.forEach.call(existingLinks, function (link) {
        var key = keyFromText(link.textContent);
        if (!key || !DESTINATIONS[key]) return;
        link.href = DESTINATIONS[key];
        link.textContent = ITEMS.filter(function (item) { return item.key === key; })[0].label;
        var li = link.closest('.mobile-menu__nav-item');
        if (li) li.setAttribute('data-cjs-vorsprung-item', key);
      });

      ITEMS.forEach(function (item) {
        if (list.querySelector('[data-cjs-vorsprung-item="' + item.key + '"]')) return;
        list.appendChild(makeMobileItem(item));
      });
    });
  }

  function updateVorsprungMenus() {
    updateCustomCjsMenu();
    updateDesktopBrandsMenu();
    updateMobileBrandsMenu();
  }

  function isRelevantTrigger(target) {
    if (!target || !target.closest) return false;
    var clickable = target.closest('a[href], button');
    if (!clickable) return false;

    var text = clean(clickable.textContent);
    var path = clickable.tagName === 'A' ? pathOf(clickable.getAttribute('href')) : '';

    return text === 'brands' ||
      text === 'brands we service' ||
      text === 'vorsprung' ||
      path === '/pages/brands-we-service';
  }

  function refreshAfterMenuOpen() {
    updateVorsprungMenus();
    window.setTimeout(updateVorsprungMenus, 80);
    window.setTimeout(updateVorsprungMenus, 220);
    window.setTimeout(updateVorsprungMenus, 500);
  }

  function handleTrigger(event) {
    if (isRelevantTrigger(event.target)) refreshAfterMenuOpen();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateVorsprungMenus, { once: true });
  } else {
    updateVorsprungMenus();
  }

  window.setTimeout(updateVorsprungMenus, 500);
  window.setTimeout(updateVorsprungMenus, 1400);

  document.addEventListener('pointerover', handleTrigger, true);
  document.addEventListener('focusin', handleTrigger, true);
  document.addEventListener('click', handleTrigger, true);
  document.addEventListener('shopify:section:load', updateVorsprungMenus);
})();
